<template>
  <WdsStack
    class="tw-bg-[#fafafa] tw-border tw-border-[#e9e9ed] tw-rounded tw-p-4 tw-pb-0 tw-shadow-sm"
    :class="colClass"
    direction-column
    gap-md
  >
    <WdsHeading v-if="title || $slots.title" type="title2" class="card-title">
      <slot name="title">{{ title }}</slot>
    </WdsHeading>

    <div>
      <slot></slot>
    </div>

    <div v-if="$slots.footer">
      <slot name="footer"></slot>
    </div>
  </WdsStack>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsHeading, WdsStack } from '@worksome/wds-components'

const props = withDefaults(
  defineProps<{
    colSpan?: '1' | '2'
    title?: string
  }>(),
  { title: '', colSpan: '1' },
)

const colClass = computed(() => `md:tw-col-span-${props.colSpan}`)
</script>

<style scoped lang="scss"></style>
